import * as React from "react";
import { Box, Typography, Stack, Container } from "@mui/material";
import { styled } from "@mui/material/styles";
import GlassCard from "./GlassCard";

interface PageLayoutProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl" | false;
  useGlassCard?: boolean;
}

const PageHeader = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: theme.spacing(2),
  flexWrap: "wrap",
}));

const PageTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  marginBottom: theme.spacing(0.5),
}));

const PageSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  marginTop: theme.spacing(0.5),
}));

const PageLayout: React.FC<PageLayoutProps> = ({
  title,
  subtitle,
  actions,
  children,
  maxWidth = false,
  useGlassCard = false,
}) => {
  const content = (
    <>
      <PageHeader>
        <Box>
          <PageTitle variant="h4">
            {title}
          </PageTitle>
          {subtitle && <PageSubtitle variant="body1">{subtitle}</PageSubtitle>}
        </Box>
        {actions && (
          <Stack direction="row" spacing={2} alignItems="center">
            {actions}
          </Stack>
        )}
      </PageHeader>
      <Box>{children}</Box>
    </>
  );

  if (maxWidth !== false) {
    return (
      <Container maxWidth={maxWidth as "xs" | "sm" | "md" | "lg" | "xl" | undefined}>
        {useGlassCard ? (
          <GlassCard elevation={6} sx={{ p: 4, mt: 2 }}>
            {content}
          </GlassCard>
        ) : (
          content
        )}
      </Container>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      {useGlassCard ? (
        <GlassCard elevation={6} sx={{ p: 4 }}>
          {content}
        </GlassCard>
      ) : (
        content
      )}
    </Box>
  );
};

export default PageLayout;

